import { createAction, props } from '@ngrx/store';
import { PromptTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { PromptOption } from '../../prompt-register/models/prompt-option.interface';
import { MailboxDetailSaveEvent } from '../models/mailbox-detail-form-submit-event';
import { VoiceMailGreetingPromptOption } from '../models/voicemail-greeting-prompt-option.model';
import { GetMailboxDetail_mailbox } from '../queries/generated/GetMailboxDetail';
import { SaveMailbox } from '../queries/generated/SaveMailbox';

export const mailboxDetailLoad = createAction('[Mailbox Detail] Load');

export const mailboxDetailCancel = createAction('[Mailbox Detail] Cancel');

export const mailboxDetailAccessDenied = createAction('[Mailbox Detail] Access Denied');

export const loadMailboxDetailSuccess = createAction(
   '[API] Load Mailbox Success',
   props<{ data: GetMailboxDetail_mailbox }>()
);

export const loadMailboxDetailFailure = createAction('[API] Load Mailbox Failure', props<SingleGraphError>());

export const saveMailboxDetail = createAction('[Mailbox Detail] Save', props<MailboxDetailSaveEvent>());

export const saveMailboxDetailSuccess = createAction('[Mailbox Detail] Save Success', props<{ data: SaveMailbox }>());

export const saveMailboxDetailFailure = createAction('[Mailbox Detail] Save Failure', props<SingleGraphError>());

export const addNewPrompt = createAction(
   '[Mailbox Detail] Add New Prompt',
   props<{ promptType: PromptTypes; voiceMailGreetingPrompt: VoiceMailGreetingPromptOption | null }>()
);

export const promptItemDialogSubmit = createAction(
   '[Mailbox Detail Prompt Dialog] Submit',
   props<{ promptItem: PromptOption }>()
);

export const editMailboxPin = createAction(
   '[Mailbox Detail] Edit Mailbox Pin',
   props<{ mailboxId: number }>()
);

export const editMailboxPinFailure = createAction('[Mailbox Detail] Edit Mailbox Pin Failure', props<{ error: string}>());

export const editMailboxPinSuccess = createAction('[Mailbox Detail] Edit Mailbox Pin Success');

export const editMailboxPinSubmit = createAction(
   '[Mailbox Detail] Edit Mailbox Pin Submit',
   props<{ password: string, mailboxId: number }>()
);
